<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M16,13C16,13,3,13,3,13C3,13,9,4,9,4C9,4,10,4,10,4C10,4,12,6,12,6C12,6,13,6,13,6C13,6,16,13,16,13C16,13,16,13,16,13ZM13.5,9.5C13.5,9.5,12.5,7,12.5,7C12.5,7,11.5,7,11.5,7C11.5,7,9.5,5,9.5,5C9.5,5,6.5,9.5,6.5,9.5C6.5,9.5,9,8,9,8C9,8,10,9,10,9C10,9,11,8,11,8C11,8,13.5,9.5,13.5,9.5C13.5,9.5,13.5,9.5,13.5,9.5ZM5.93956,7C5.93956,7,1.81835,13,1.81835,13C1.81835,13,0,13,0,13C0,13,5,7,5,7C5,7,5.93956,7,5.93956,7C5.93956,7,5.93956,7,5.93956,7Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Mountain',
} as DefineComponent
</script>
